import React from 'react';

const useActiveField = () => {
  const [activeField, setActiveField] = React.useState('');

  const handleFocus = React.useCallback(({ target: { name } }) => {
    setActiveField(name);
  }, []);

  const handleBlur = React.useCallback(() => {
    setActiveField('');
  }, []);

  return { handleFocus, activeField, handleBlur };
};

export default useActiveField;
